import { ChangeDetectionStrategy, Component } from '@angular/core'

import { LayoutTestimonials } from 'app/core/cms/generated/api-types'
import { CarouselComponent } from 'app/shared/carousel/carousel.component'
import { CarouselItemDirective } from 'app/shared/carousel/carousel-item.directive'

import { CmpTestimonialComponent } from '../../cmps/cmp-testimonial/cmp-testimonial.component'
import { CmsBlock } from '../../cms-block'

@Component({
  selector: 'pai-layout-testimonials',
  templateUrl: './layout-testimonials.component.html',
  styleUrls: ['./layout-testimonials.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CarouselComponent, CarouselItemDirective, CmpTestimonialComponent],
  providers: [{ provide: CmsBlock, useExisting: LayoutTestimonialsComponent }],
})
export class LayoutTestimonialsComponent extends CmsBlock<LayoutTestimonials> {
  readonly __typename = 'LayoutTestimonials'
}
